import React from 'react';
import { BrainIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, BOX_IMAGE_ALT, finalFlow, finalSteps } from '../data/content';
export function FinalCta() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-42" data-mp="19gifkx2wp70s">
      <div className="mx-auto flex max-w-[720px] flex-col items-center text-center" data-id="element-43" data-mp="15caurazkkb7u">
        <h2 className="text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2rem]" data-id="element-44" data-mp="1jcd4ub1my0cj">
          One last question
        </h2>
        <p className="mt-4 max-w-[600px] text-[1rem] leading-relaxed text-white/90" data-id="element-45" data-mp="1ebxttq4tt4xq">
          When you're preparing an Anatomy & Physiology lesson and the
          diagrams, worksheets, activities, assessments, and resources are
          spread across different places...
        </p>
        <p className="mt-3 max-w-[600px] text-balance text-[1.15rem] font-extrabold leading-snug text-white" data-id="element-46" data-mp="223w6adg0h6cg">
          Do you immediately have everything you need for the class?
        </p>
        <p className="mt-3 max-w-[600px] text-[1rem] leading-relaxed text-white/90" data-id="element-47" data-mp="n75npw4mel58">
          Stop jumping between scattered references and rebuilding every topic
          from different materials.
        </p>

        <ol className="mt-6 grid w-full max-w-[600px] grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-48" data-mp="x5v6rs896bn2">
          {finalSteps.map(step => <li key={step} className="rounded-md bg-slate-900 px-3 py-3 text-[0.9rem] font-bold text-white" data-id="element-49" data-mp="164qcl37dxjpu">
              {step}
            </li>)}
        </ol>

        <p className="mt-5 text-[1rem] font-extrabold uppercase tracking-tight text-orange-500 sm:text-[1.15rem]" data-id="element-50" data-mp="1ftqfgxp0cz9b">
          Teach. Show. Practice. Review.
        </p>

        <img src={BOX_IMAGE} alt={BOX_IMAGE_ALT} className="mt-6 w-full max-w-[300px]" width={1240} height={1240} data-id="element-51" data-mp="1kv7c2h0glzk3" />

        <p className="mt-6 flex items-center justify-center gap-2 text-[1.15rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.3rem]" data-id="element-52" data-mp="1tuaxhrn3mr1r">
          <BrainIcon className="h-5 w-5" aria-hidden="true" data-id="element-53" data-mp="3lwnbs2y7uia8" />
          ANATOMY READY™
        </p>
        <p className="mt-2 max-w-[560px] text-balance text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[1.15rem]" data-id="element-54" data-mp="3imt4be98tb8">
          The Complete Visual Teaching System for Anatomy & Physiology Teachers
        </p>
        <p className="mt-3 text-[0.8rem] font-bold uppercase tracking-[0.18em] text-white/80" data-id="element-55" data-mp="dhvjku9wvpsu">
          {finalFlow.join(' • ')}
        </p>

        <CtaButton label="Get the complete system today" subLabel="Get ANATOMY READY™" className="mt-6 w-full max-w-[460px]" data-id="element-56" data-mp="mgqqy9ooz5xq" />

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[0.75rem] font-bold uppercase tracking-wide text-white/85" data-id="element-57" data-mp="id16nwf1vaii">
          <li className="flex items-center gap-1.5" data-id="element-58" data-mp="2k7jxjruco462">
            <ZapIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" aria-hidden="true" data-id="element-59" data-mp="2a2a69k6yv9ds" />
            Immediate Access • Digital Delivery
          </li>
          <li className="flex items-center gap-1.5" data-id="element-60" data-mp="2e3do2c8krfhn">
            <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" aria-hidden="true" data-id="element-61" data-mp="20cqn0dfcddie" />
            7-Day Money-Back Guarantee
          </li>
        </ul>
      </div>
    </section>;
}